'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = angular.module('ifeis.focus', []).directive('fFocus', function ($timeout) {
  return {
    link: function link(scope, element, attrs) {
      scope.$watch(attrs.fFocus, function (val) {
        $timeout(function () {
          return val && element.focus();
        });
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./focus/index.js
// module id = 210
// module chunks = 0